import axios from 'axios';
import Config from '../../../config';
import { set } from 'date-fns';

const fetchExams = async (difficultyId, setExams, setError) => {
    try {
        const res = await axios.get(`/coordinators/exam-details/?difficulty_id=${difficultyId}`);
        setExams(res.data);
    } catch (err) {
        setError("Failed to fetch assessments. Please try again later.");
    }
};


const fetchAssignmentDetails = async (setAssignments, setError) => {
    try {
        const res = await axios.get(`/coordinators/assignment-type-list/`);
        const assignmentData = res.data?.data.map(item => ({
            id: item.Id,
            name: item.AssignmentType
        }));
        setAssignments(assignmentData);
    } catch (err) {
        setError("Failed to fetch assignment assessments. Please try again later.");
    }
};

const fetchAssignedExamDetails = async (
    assignedId, 
    setAssignedData,
    setError) => {
    try {
        const res = await axios.get(`${Config.COORDINATOR_URL}/coordinators/assign-exam?assignedId=${assignedId}`);
        
        setAssignedData(res.data?.data);

        console.log("Assigned Assessment Details:", res.data?.data);
        return res.data?.data;

    } catch (err) {
        console.error("Error fetching assigned assessment details:", err);
        setError("Failed to fetch assignment details. Please try again later.");
    }
};


const fetchSchedulingConfig = async () => {
    try {
        const res = await axios.get(
            `${Config.COORDINATOR_URL}/coordinators/scheduling-config/`
        );

        return res.data.autoScheduling;
    } catch (err) {
        console.error(err);

        // Default Auto Scheduling
        return 1;
    }
};








// Updated fetch function for the frontend
const fetchAllExams = async (setExams, setError) => {
    try {
        const res = await axios.get(`/coordinators/all-exams/`);
        setExams(res.data);
    } catch (err) {
        setError("Failed to fetch assessments. Please try again later.");
        console.error("Error fetching exams:", err);
    }
};


export { fetchExams, fetchAssignmentDetails, fetchAssignedExamDetails , fetchAllExams,fetchSchedulingConfig};